var exports = {
  "Q": "xe533113f--a85718--button-phone-container",
  "Y": "xe533113f--a85718--button-tablet",
};

module.exports = exports;
